import { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => { document.title = "תנאי שימוש | topiqz"; }, []);
  return (
    <main id="main-content" className="privacy-page" dir="rtl">
      <nav aria-label="חזרה לדף הבית" className="privacy-back-nav">
        <a href="/">← חזרה לדף הראשי</a>
      </nav>
      <div className="privacy-content">
        <h1>תנאי שימוש</h1>

        <p>
          ברוכים הבאים לאפליקציה ללימוד אוצר מילים באנגלית לילדים
          ישראלים בכיתות א׳ עד ה׳. האפליקציה מופעלת על ידי{" "}
          <strong>אדם פרטי בישראל</strong> (להלן: &ldquo;מפעיל
          האפליקציה&rdquo;), ללא מטרות רווח.
        </p>
        <p>
          השימוש באפליקציה מהווה הסכמה לתנאים המפורטים להלן. אם אינכם מסכימים
          לתנאים אלו, אנא הימנעו משימוש באפליקציה.
        </p>

        {/* ── Section 1: Service description ──
            Grounded in: Meta Business Verification website checklist — reviewers
            require a "clear business description and services" on the website.
            See https://business.whatsapp.com/policy §2 (escalation paths). */}
        <h2>1. תיאור השירות</h2>
        <p>
          האפליקציה מיועדת לתרגול אוצר מילים באנגלית לילדים בגילאי
          6-12, בהתאם לתכנית הלימודים של משרד החינוך (2020). השירות כולל:
        </p>
        <ul>
          <li>תרגול באמצעות כרטיסיות, שאלות רב-ברירה והשלמת משפטים.</li>
          <li>שיחה קולית חיה עם מורה AI (מבוססת Google Gemini).</li>
          <li>
            שאלון יומי אופציונלי ב-WhatsApp (מופעל רק באישור מפורש של ההורה).
          </li>
          <li>לוח בקרה להורים לניהול פרופילי ילדים ומעקב אחר התקדמות.</li>
        </ul>

        {/* ── Section 2: Registration ──
            Grounded in: WhatsApp Business Terms of Service §3 ("Registration and
            Account") — requires accurate, current, and complete registration info.
            Also: WhatsApp Business Terms §4 ("Company must also secure all necessary
            rights, consents, and permissions (for example, opt-in)").
            Also: Israeli Privacy Protection Law 5741-1981 — requires explicit,
            informed parental consent for collecting data on minors. */}
        <h2>2. הרשמה וחשבונות</h2>
        <ul>
          <li>
            הרשמה לאפליקציה מתבצעת על ידי <strong>הורה בלבד</strong> באמצעות
            חשבון Google. ההורה מאשר בכך שהוא מעל גיל 18 ומורשה לפעול עבור
            ילדיו.
          </li>
          <li>
            ההורה אחראי ליצירת פרופילי הילדים ולניהולם, כולל הזנת מספר WhatsApp
            (אם רלוונטי). הסכמת ההורה ליצירת פרופיל מהווה את ההסכמה המפורשת
            הנדרשת לפי חוק הגנת הפרטיות, התשמ&rdquo;א-1981.
          </li>
          <li>
            ילדים נכנסים לאפליקציה דרך קישור אישי (Magic Link) שנוצר עבורם —
            ללא שם משתמש או סיסמה.
          </li>
          <li>
            ההורה אחראי לשמור את הקישור האישי במקום בטוח ולא לשתף אותו עם מי
            שאינו מורשה.
          </li>
        </ul>

        {/* ── Section 3: Acceptable use ──
            Grounded in: WhatsApp Business Terms of Service §6 ("Acceptable Use")
            and Meta Business Verification checklist (requires "terms of service
            and acceptable use policy" on website). */}
        <h2>3. שימוש מותר</h2>
        <p>האפליקציה מיועדת לשימוש אישי ולימודי בלבד. אין להשתמש בה:</p>
        <ul>
          <li>למטרות מסחריות או לצרכי רווח.</li>
          <li>באופן שמפר זכויות קניין רוחני של צדדים שלישיים.</li>
          <li>
            באופן שעלול לפגוע בשירות, בשרתים, או בחוויית המשתמשים האחרים.
          </li>
          <li>לשליחת תוכן פוגעני, בלתי חוקי או בלתי הולם.</li>
        </ul>

        {/* ── Section 4: AI content ──
            No direct legal requirement, but best practice for transparency per
            Israeli Privacy Protection Law (purpose limitation / informed consent)
            and EU AI Act transparency obligations (relevant for EU-region users). */}
        <h2>4. תוכן שנוצר על ידי AI</h2>
        <p>
          חלק מהשאלות והמשפטים באפליקציה נוצרים באמצעות בינה מלאכותית (Google
          Gemini). למרות שהמערכת מתוכננת לייצר תוכן לימודי מדויק ובטוח:
        </p>
        <ul>
          <li>ייתכנו טעויות נדירות בתוכן שנוצר אוטומטית.</li>
          <li>
            האפליקציה אינה מהווה תחליף להוראה מקצועית או לתכנית לימודים
            בית-ספרית.
          </li>
          <li>
            שום מידע אישי על הילד אינו נשלח לשירות ה-AI — רק מילים באנגלית
            לצורך יצירת שאלות.
          </li>
        </ul>

        {/* ── Section 5: WhatsApp ──
            Grounded in: WhatsApp Business Messaging Policy §1 (opt-in: "they have
            given you their mobile phone number" + "received opt-in permission").
            Also: §2 (escalation paths must be available).
            Also: WhatsApp Business Terms §4 ("Company must also secure all necessary
            rights, consents, and permissions (for example, opt-in) to share its
            customers' contact and other personal data with WhatsApp").
            Also: Best Practices section recommends "separate opt-in by specific
            message category." */}
        <h2>5. WhatsApp — הודעות יומיות</h2>
        <p>אם ההורה בוחר להפעיל את תכונת התרגול ב-WhatsApp:</p>
        <ul>
          <li>
            נשלחת <strong>שאלה לימודית אחת ביום</strong> בשעה 16:00 (שעון
            ישראל).
          </li>
          <li>
            ההודעות מכילות תוכן לימודי בלבד — ללא פרסומות, מבצעים, או קישורים
            חיצוניים.
          </li>
          <li>
            הזנת מספר WhatsApp על ידי ההורה בלוח הבקרה מהווה הסכמה מפורשת
            (opt-in) לקבלת הודעות, כנדרש על ידי{" "}
            <a
              href="https://business.whatsapp.com/policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              מדיניות הודעות WhatsApp Business
            </a>
            .
          </li>
          <li>
            ההורה רשאי להפסיק את ההודעות בכל רגע על ידי הסרת מספר הטלפון מלוח
            הבקרה, או על ידי חסימת המספר ב-WhatsApp.
          </li>
          <li>
            השימוש בשירות WhatsApp כפוף גם ל
            <a
              href="https://www.whatsapp.com/legal/business-terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              תנאי השימוש של WhatsApp Business
            </a>
            .
          </li>
        </ul>

        {/* ── Section 6: Data and privacy ──
            Grounded in: WhatsApp Business Terms §4 ("Company must provide all
            necessary data disclosures and notices (such as maintaining a privacy
            policy)"). Also: WhatsApp Business Messaging Policy §3 ("maintaining
            a published privacy policy"). Also: Israeli Privacy Protection Law
            5741-1981 §§11-13 (rights of data subjects). */}
        <h2>6. פרטיות ומידע אישי</h2>
        <p>
          השימוש באפליקציה כפוף ל
          <a href="/privacy">מדיניות הפרטיות</a> שלנו, המפרטת אילו נתונים
          נאספים, כיצד הם מעובדים, ומהן הזכויות שלכם לפי חוק הגנת הפרטיות,
          התשמ&rdquo;א-1981. מפעיל האפליקציה הוא בעל השליטה (Controller) על
          המידע הנאסף.
        </p>

        {/* ── Section 7: IP ──
            Standard legal term; referenced structure from WhatsApp Business
            Terms §5 ("Licenses and Intellectual Property"). */}
        <h2>7. קניין רוחני</h2>
        <p>
          כל הזכויות באפליקציה, בעיצוב, בקוד ובתוכן המקורי שייכות למפעיל
          האפליקציה. רשימת אוצר המילים מבוססת על תכנית הלימודים הפומבית של משרד
          החינוך (2020).
        </p>

        {/* ── Section 8: Liability limitation ──
            Standard legal term; referenced structure from WhatsApp Business
            Terms §10 ("Disclaimers" — "AS IS" / no warranty). */}
        <h2>8. הגבלת אחריות</h2>
        <ul>
          <li>
            האפליקציה מסופקת <strong>&ldquo;כמו שהיא&rdquo; (as-is)</strong>,
            ללא אחריות מכל סוג, מפורשת או משתמעת.
          </li>
          <li>
            מפעיל האפליקציה אינו אחראי לנזק ישיר או עקיף שנובע מהשימוש
            באפליקציה, כולל הפסקות שירות, אובדן נתונים, או טעויות בתוכן שנוצר
            על ידי AI.
          </li>
          <li>
            האפליקציה היא כלי עזר לימודי ואינה מהווה תחליף להוראה רשמית.
          </li>
        </ul>

        {/* ── Section 9: Termination ──
            Grounded in: WhatsApp Business Terms §6 ("Enforcement") — WhatsApp
            can suspend/terminate for violations; mirrored for our own service.
            Also: Israeli Privacy Protection Law §§13-14 (deletion rights). */}
        <h2>9. סיום שימוש</h2>
        <p>
          מפעיל האפליקציה רשאי להשעות או לסגור חשבון בכל עת, במיוחד במקרים של
          הפרת תנאי שימוש אלו. כמו כן, ההורה רשאי לבקש מחיקת החשבון וכל
          הנתונים בכל עת על ידי פנייה ל
          <a href="mailto:perestom@gmail.com">perestom@gmail.com</a>, בהתאם
          לזכות העיון והמחיקה שבחוק הגנת הפרטיות.
        </p>

        {/* ── Section 10: Support / escalation ──
            Grounded in: WhatsApp Business Messaging Policy §2 — requires
            "prompt, clear, and direct escalation paths" including "Email"
            and "Web support (on the business website)". */}
        <h2>10. יצירת קשר ותמיכה</h2>
        <p>
          לכל שאלה, בעיה טכנית, או בקשה הנוגעת לשירות, ניתן לפנות למייל:{" "}
          <a href="mailto:perestom@gmail.com">perestom@gmail.com</a>. אנו
          מתחייבים להשיב בהקדם האפשרי.
        </p>

        {/* ── Section 11: Governing law ──
            Required for Israeli-operated service; references Israeli law. */}
        <h2>11. דין חל</h2>
        <p>
          על תנאים אלו יחולו דיני מדינת ישראל. סמכות השיפוט הבלעדית תהיה
          לבתי המשפט המוסמכים בישראל.
        </p>

        {/* ── Section 12: Changes ──
            Standard clause; mirrors WhatsApp Business Messaging Policy §7
            ("WhatsApp may update this Policy… without notice"). */}
        <h2>12. שינויים בתנאים</h2>
        <p>
          מפעיל האפליקציה רשאי לעדכן תנאים אלו מעת לעת. שינויים מהותיים
          יפורסמו באפליקציה, והמשך השימוש לאחר העדכון מהווה הסכמה לתנאים
          החדשים.
        </p>

        <p className="privacy-consent">
          המשך שימוש באפליקציה מהווה הסכמה לתנאי שימוש אלו
          ול<a href="/privacy">מדיניות הפרטיות</a> שלנו.
        </p>

        <p className="privacy-updated">עודכן לאחרונה: אפריל 2026</p>
      </div>
    </main>
  );
}
